module.exports = __webpack_public_path__ + "img/11@2x.b6b15078.png";